import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';

import Grid from '@material-ui/core/Grid';
import LoadingSpinner from 'components/LoadingSpinner';
import DropdownInput from 'components/DropdownInput';
import MenuControls from 'components/Widget/components/menus/MainSettings/components/MenuControls';
import { Message } from 'components/shared';

const validationError =
  'This is the original position of the dashboard! Please select another one or leave the menu.';

const useStyles = makeStyles({
  root: {
    flexGrow: 1
  },
  rootInput: {
    '& .MuiOutlinedInput-input': {
      padding: '15px 14px'
    }
  },
  modal_subtitle: {
    marginBottom: '30px'
  }
});

const SwapDashboardPopup = ({
  dashboardMenuProps,
  handleSubmit,
  state,
  onClose,
  dashboardsCount
}) => {
  const classes = useStyles();
  const { isLoading, isError, error } = state;

  const [position, setPosition] = useState(dashboardMenuProps.tabOrdinal);
  const [isValidationError, setIsValidationError] = useState(false);

  const handlePositionChange = event => {
    setPosition(event.target.value);
  };

  const onSubmit = () => {
    if (position === dashboardMenuProps.tabOrdinal) {
      setIsValidationError(true);
      return;
    }
    handleSubmit({ ...dashboardMenuProps, newDashboardId: null, firstOrdinal: position });
  };
  const dashboardOrdinalsArray = [...Array(dashboardsCount).keys()].map(x => ({
    label: x + 1,
    value: x + 1
  }));

  return (
    <>
      <h2>Swap dashboards</h2>
      <Typography className={classes.modal_subtitle} gutterBottom>
        Choosing a different dashboard position value will switch the places of the currently
        selected dashboard and the dashboard on the chosen index.
      </Typography>

      {isLoading && <LoadingSpinner />}
      {!isLoading && (
        <Grid
          container
          direction="row"
          justify="center"
          alignItems="flex-start"
          spacing={3}
          className={classes.root}
        >
          <Grid item container direction="column" xs={12} md={6}>
            <h3>Current dashboard position</h3>
            <Typography variant="h5" className={classes.modal_subtitle} gutterBottom>
              {dashboardMenuProps.tabOrdinal}
            </Typography>
          </Grid>
          <Grid item container direction="column" xs={12} md={6}>
            <h3>Dashboard position</h3>
            <DropdownInput
              selected={position}
              options={dashboardOrdinalsArray}
              onSelect={handlePositionChange}
              label="Choose..."
              name="value"
            />
          </Grid>
          {isError ||
            (isValidationError && (
              <Grid item xs={12}>
                <Message type="error" text={error || validationError} />;
              </Grid>
            ))}
        </Grid>
      )}

      <Box style={{ marginLeft: '-23px' }} mt={6}>
        <MenuControls
          handleClose={onClose}
          useFormSubmit={false}
          onSubmit={onSubmit}
          disabled={position === dashboardMenuProps.tabOrdinal || isLoading}
        />
      </Box>
    </>
  );
};

SwapDashboardPopup.propTypes = {
  onClose: PropTypes.func.isRequired,
  dashboardsCount: PropTypes.number.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  dashboardMenuProps: PropTypes.shape({ tabOrdinal: PropTypes.number.isRequired }).isRequired,
  state: PropTypes.shape({
    isLoading: PropTypes.bool,
    isError: PropTypes.bool,
    error: PropTypes.string,
    data: PropTypes.shape({})
  }).isRequired
};

export default SwapDashboardPopup;
